var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"x-small":"","icon":""},on:{"click":_vm.copyContent}},[_c('v-icon',[_vm._v("content_copy")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }